import dayjs from 'dayjs';
import { StatisticsInvoiceRow } from '../../types';

/** Sinh dữ liệu mẫu — cùng ngày để lọc “Hôm nay” hiển thị đủ dòng như ảnh */
export function generateMockStatisticsRows(): StatisticsInvoiceRow[] {
  const created = dayjs().hour(9).minute(25).second(0);
  const sent = dayjs().hour(10).minute(25).second(0);

  return Array.from({ length: 11 }, (_, i) => ({
    id: i + 1,
    invoice_id: (i % 3) + 1,
    invoice_number: String(245 + i),
    customer_name: 'Nguyễn Cẩm Nhung',
    service_name: 'Xuất hóa đơn',
    note: 'Khám tại phòng khám',
    created_at: created.format('YYYY-MM-DDTHH:mm:ss'),
    sent_at: sent.format('YYYY-MM-DDTHH:mm:ss'),
    total_amount: '120000',
    doctor_id: i % 2 === 0 ? 1 : 2,
  }));
}

export interface StatisticsFilterParams {
  startDate: string;
  endDate: string;
  service_name?: string;
  doctor_id?: number;
}

export function filterMockStatisticsRows(
  rows: StatisticsInvoiceRow[],
  params: StatisticsFilterParams
): StatisticsInvoiceRow[] {
  let list = rows.filter((r) => {
    const day = dayjs(r.created_at).format('YYYY-MM-DD');
    return day >= params.startDate && day <= params.endDate;
  });

  if (params.service_name) {
    list = list.filter((r) => r.service_name === params.service_name);
  }
  if (params.doctor_id != null) {
    list = list.filter((r) => r.doctor_id === params.doctor_id);
  }

  return list;
}
